module.exports = __webpack_public_path__ + "static/media/SPART.be64c655.svg";